<template>
  <v-app>
    <v-app-bar app>
      <template v-slot:default>
        <Navbar class="pa-0" />
      </template>
    </v-app-bar>
    <v-content>
      <router-view />
      <v-snackbar
        v-if="hasError"
        v-model="hasError"
        :timeout="timeout"
        color="red"
        class="pb-10"
      >
        {{ error.errorMessage }}
        <v-btn text @click="handleReset()">
          Dismiss
        </v-btn>
      </v-snackbar>
    </v-content>
    <v-footer app color="#145392" absolute class="white--text">
      <v-col class="text-center ma-0 pa-0">
        {{ footerText.message }}<a style="color: inherit" :href="`mailto:${footerText.link}`">{{ footerText.link }}</a>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import Navbar from './components/Navbar';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'App',
  components: {
    Navbar
  },
  data () {
    return {
      timeout: 0,
      registrationLanguage: {
        message: 'Still have questions? Call (866) 884-4680 Option 3 or email ',
        link: 'support@hawksoft.com'
      },
      marketplaceLanguage: {
        message: 'Have a question? Call (866) 884-4680 Option 4, or email ',
        link: 'insidesales@hawksoft.com'
      }
    };
  },
  computed: {
    ...mapState(['error']),
    hasError: function () {
      return (this.error || null) !== null;
    },
    footerText: function () {
      if (this.$route.path.includes('registration')) {
        return this.registrationLanguage;
      }
      return this.marketplaceLanguage;
    }
  },
  created () {
    if (this.$route.path.startsWith('/eSignatureActivation') || this.$route.path.startsWith('/error')) {
      // This needs to happen first, we won't have auth on these routes.

    }
  },
  methods: {
    ...mapActions(['resetError']),
    async handleReset () {
      this.resetError();
    }
  }
};
</script>

<style lang="scss">
// Fonts / Icons
@import url('https://cdn.jsdelivr.net/npm/@mdi/font@4.x/css/materialdesignicons.min.css');

  #app {
  font-family: 'Open Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
// General Styles
.font-title{
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 33px;
  color: #4f4f4f;
}
.v-toolbar__content {
  padding: 0px
}
.font-subtitle{
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
  color: #4F4F4F;
}

.font-standard{
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 18px;
  color: #4F4F4F;
}

.font-subtext{
  font-family: Open Sans;
  font-style: italic;
  font-weight: normal;
  font-size: 14px;
  line-height: 14px;
  color: #767676;
}

.v-btn{
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}
</style>
